// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__signup_container {
  background-color: #0d0c0c;
}
@media (max-width: 576px) {
  .__signup_container {
    background-color: black;
  }
}
.__signup_container .bg_video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
@media (max-width: 576px) {
  .__signup_container .bg_video {
    border-bottom: 2px solid #FFEE20;
    height: 62%;
  }
}
.__signup_container .__signup {
  background-color: transparent;
  position: absolute;
  width: 444px;
  top: 0;
  bottom: 0;
  right: 0;
}
@media (max-width: 576px) {
  .__signup_container .__signup {
    width: 100%;
    height: 50%;
    position: initial;
  }
}
@media (min-width: 2000px) and (max-width: 2500px) {
  .__signup_container .__signup {
    max-width: 700px;
    width: 700px;
  }
}
@media (min-width: 2501px) and (max-width: 4000px) {
  .__signup_container .__signup {
    max-width: 900px;
    width: 900px;
  }
}
.__signup_container .__signup .___signup_header {
  padding: 0 58px;
  position: absolute;
  top: 60px;
}
.__signup_container .__signup .___signup_header .___title {
  font-size: 45px;
  font-family: "Anton", sans-serif;
  color: #ffffff;
  margin: 0;
}
.__signup_container .__signup .___signup_header .___signup_moto {
  display: flex;
  align-items: center;
}
.__signup_container .__signup .___signup_header .__hero_title {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
}
@media (max-width: 576px) {
  .__signup_container .__signup .___signup_header .__hero_title {
    flex-direction: column;
  }
}
.__signup_container .__signup .___signup_header .__hero_title p {
  font-family: "Helvetica Neue", sans-serif;
  font-size: 30px;
  font-weight: bold;
}
.__signup_container .__signup .__signup_action {
  position: absolute;
  top: 15%;
  padding: 0 58px;
  width: auto;
  margin: auto auto 30px auto;
  left: 0;
  right: 0;
}
@media (max-width: 576px) {
  .__signup_container .__signup .__signup_action .login_text {
    display: none;
  }
}
.__signup_container .__signup .__signup_action .image_container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
  margin-top: 50%;
}
.__signup_container .__signup .__signup_action .image_container .bot_icon {
  width: 70%;
  height: 70%;
  object-fit: contain;
}
@media (max-width: 1036px) {
  .__signup_container .__signup .__signup_action {
    bottom: 0;
    top: auto;
  }
}
@media (max-width: 576px) {
  .__signup_container .__signup .__signup_action {
    bottom: 5%;
    top: auto;
  }
}
.__signup_container .__signup .__signup_action .gradient_box {
  background-image: linear-gradient(rgba(0, 0, 0, 0.8) -10%, #FFFFFF);
  border-radius: 20rem;
  padding: 1px;
}
.__signup_container .__signup .__signup_action .__action {
  display: flex;
  background-color: black;
  padding: 16px;
  border-radius: 20rem;
  justify-content: center;
  position: relative;
}

.__signup_container_gender {
  height: 100vh;
  background-color: #0d0c0c;
}
@media (min-height: 550px) and (max-height: 739px) {
  .__signup_container_gender {
    height: 130vh;
  }
}
@media (max-width: 576px) {
  .__signup_container_gender {
    background-color: #1e1e1e;
  }
}
.__signup_container_gender .__signup_gender {
  background-color: #1e1e1e;
  position: absolute;
  max-width: 444px;
  width: 444px;
  height: 736px;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  right: 0;
}
@media (min-height: 550px) and (max-height: 739px) {
  .__signup_container_gender .__signup_gender {
    margin: 40px auto;
  }
}
@media (max-width: 576px) {
  .__signup_container_gender .__signup_gender {
    width: 100%;
    height: 100%;
    margin: 0;
  }
}
.__signup_container_gender .__signup_gender .__signup_image {
  position: absolute;
  top: 0;
  right: 0;
}
.__signup_container_gender .__signup_gender .___gender {
  padding: 0 58px;
  margin-top: 60px;
}
.__signup_container_gender .__signup_gender .___gender .__gender_ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container {
  margin-top: 20px;
  align-items: center;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_gender {
  transition: flex 1s;
  width: 210px;
  background: #262626;
  padding: 10px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_gender:hover {
  background: #000000;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_gender .__gender_name {
  color: rgba(255, 255, 255, 0.3137254902);
  font-size: 17px;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_gender .__done_icon {
  display: none;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__gender_active {
  width: 210px;
  background: #000000;
  justify-content: space-between;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__gender_active .__gender_name {
  color: #ffffff;
  font-size: 17px;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__gender_active .__done_icon {
  display: block;
  background: #FFEE20;
  border-radius: 50%;
  color: #000000;
  font-size: 11px;
  padding: 2px;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_language {
  position: relative;
  transition: height 1s;
  width: 210px;
  background: #262626;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  height: 50px;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_language .__open_select_language {
  position: absolute;
  width: inherit;
  overflow: scroll;
  position: relative;
  transition: height 1s;
  width: 210px;
  background: #262626;
  border-radius: 0 0 25px 25px;
  align-items: center;
  justify-content: center;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_language .__open_select_language p {
  height: 30px;
  text-align: start;
  display: flex;
  align-items: center;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__select_language .__open_select_language p:hover {
  background: #000000;
}
.__signup_container_gender .__signup_gender .___gender .__gender_container .__open__language {
  border-radius: 25px 0 0 25px;
}

@media (max-width: 576px) {
  .__bottom_bg_box_loggedIn {
    background-color: #1e1e1e;
  }
}

.__bottom_bg_box {
  width: 100vw;
  position: "absolute";
  top: 0;
  height: 0vh;
}
.__bottom_bg_box .login_text_sm {
  display: none;
}
@media (max-width: 576px) {
  .__bottom_bg_box .login_text_sm {
    display: block;
  }
  .__bottom_bg_box {
    height: 45vh;
    bottom: 0px;
  }
}

.__bottom_box {
  width: 100%;
  height: 170px;
  background: #020101 0% 0% no-repeat padding-box;
  filter: blur(25px);
  border-radius: 43px;
  position: absolute;
  bottom: 0px;
}
@media (max-width: 576px) {
  .__bottom_box {
    background: transparent;
  }
}

.text {
  font-size: 14px;
  color: #828282;
  text-align: center;
}

#fname {
  text-align: center;
  color: #FFFFFF;
  border: #262626;
  font-size: 17px;
}

.save_btn {
  margin-top: 0 !important;
  margin-bottom: 10px !important;
}

.__signage {
  background-color: #1e1e1e;
  position: absolute;
  top: 2vh;
  height: fit-content;
  max-width: 444px;
  width: 444px;
  margin: auto;
  left: 50%;
  transform: translate(-50%, 0);
}
.__signage .__signup_image {
  position: absolute;
  top: 0;
  right: 0;
}
.__signage .___signup_header {
  padding: 0 58px;
  position: absolute;
  top: 60px;
}
.__signage .___signup_header .___title {
  font-size: 45px;
  font-family: "Anton", sans-serif;
  color: #ffffff;
  margin: 0;
}
.__signage .___signup_header .___signup_moto {
  display: flex;
  align-items: center;
}
.__signage .___signup_header .__hero_title {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
}
@media (max-width: 576px) {
  .__signage .___signup_header .__hero_title {
    flex-direction: column;
  }
}
.__signage .___signup_header .__hero_title p {
  font-family: "Helvetica Neue", sans-serif;
  font-size: 30px;
  font-weight: bold;
}
.__signage .__signup_action {
  position: absolute;
  bottom: 0px;
  padding: 0 58px;
  width: auto;
  margin: auto auto 30px auto;
  left: 0;
  right: 0;
}
.__signage .__signup_action .__action {
  border: 1px solid #ffffff;
  padding: 16px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
}
.__signage .___gender {
  padding: 0 58px;
  margin-top: 60px;
}
.__signage .___gender .__gender_ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.__signage .___gender .__gender_container {
  margin-top: 24px;
  align-items: center;
}
.__signage .___gender .__gender_container .__select_gender {
  transition: flex 1s;
  min-width: 210px;
  cursor: pointer;
  background: #262626;
  padding: 10px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
}
.__signage .___gender .__gender_container .__select_gender:hover {
  background: #000000;
}
.__signage .___gender .__gender_container .__select_gender .__gender_name {
  color: rgba(255, 255, 255, 0.3137254902);
  font-size: 17px;
}
.__signage .___gender .__gender_container .__select_gender .__done_icon {
  display: none;
}
.__signage .___gender .__gender_container .__gender_active {
  background: #000000;
  justify-content: space-between;
}
.__signage .___gender .__gender_container .__gender_active .__gender_name {
  color: #ffffff;
  font-size: 17px;
}
.__signage .___gender .__gender_container .__gender_active .__done_icon {
  display: block;
  background: #FFEE20;
  border-radius: 50%;
  color: #000000;
  font-size: 11px;
  padding: 2px;
}

.siki_logo {
  font-family: Anton !important;
  font-size: 28px !important;
  line-height: 28px !important;
  text-align: center;
  position: absolute;
  color: #fff;
  left: 45%;
  display: none;
}
@media (max-width: 576px) {
  .siki_logo {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/pages/Signup/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACE,yBAAA;AA4BF;ADME;ECnCF;IAII,uBAAA;EA6BF;AACF;AA3BE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AA6BJ;ADJE;EC5BA;IAMI,gCAAA;IACA,WAAA;EA8BJ;AACF;AA3BE;EACE,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AA6BJ;ADlBE;ECjBA;IASI,WAAA;IACA,WAAA;IACA,iBAAA;EA8BJ;AACF;ADeE;ECzDA;IAeI,gBAAA;IACA,YAAA;EA+BJ;AACF;ADSE;ECzDA;IAoBI,gBAAA;IACA,YAAA;EAgCJ;AACF;AA7BI;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AA+BN;AA7BM;EACE,eAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;AA+BR;AA5BM;EACE,aAAA;EACA,mBAAA;AA8BR;AA3BM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AA6BR;ADzDE;ECyBI;IAMI,sBAAA;EA8BR;AACF;AA5BQ;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;AA8BV;AArBI;EAEE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;AAsBN;AD5EE;ECwDI;IAEI,aAAA;EAsBR;AACF;AApBM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAsBR;AAnBQ;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAqBV;AAhBM;EA/BF;IAgCI,SAAA;IACA,SAAA;EAmBN;AACF;ADnGE;EC8CE;IAqCI,UAAA;IACA,SAAA;EAoBN;AACF;AAlBM;EACE,mEAAA;EACA,oBAAA;EACA,YAAA;AAoBR;AAlBM;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;AAoBR;;AAbA;EACE,aAAA;EACA,yBAAA;AAgBF;AD7EE;EC2DF;IAKI,aAAA;EAiBF;AACF;ADhIE;ECyGF;IASI,yBAAA;EAkBF;AACF;AAhBE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;AAkBJ;ADnGE;ECuEA;IAaI,iBAAA;EAmBJ;AACF;ADtJE;ECqHA;IAiBI,WAAA;IACA,YAAA;IACA,SAAA;EAoBJ;AACF;AAjBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAmBN;AAhBI;EACE,eAAA;EACA,gBAAA;AAkBN;AAhBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAkBR;AAfM;EACE,gBAAA;EACA,mBAAA;AAiBR;AAfQ;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAiBV;AAfU;EACE,mBAAA;AAiBZ;AAdU;EACE,wCAAA;EACA,eAAA;AAgBZ;AAbU;EACE,aAAA;AAeZ;AAXQ;EACE,YAAA;EACA,mBAAA;EACA,8BAAA;AAaV;AAXU;EACE,cAAA;EACA,eAAA;AAaZ;AAVU;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAYZ;AARQ;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAUV;AARU;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,uBAAA;AAUZ;AARY;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAUd;AARc;EACE,mBAAA;AAUhB;AAJQ;EACE,4BAAA;AAMV;;ADrPE;ECwPF;IAEI,yBAAA;EAAF;AACF;;AAGA;EACE,YAAA;EACA,oBAAA;EACA,MAAA;EACA,WAAA;AAAF;AAEE;EACE,aAAA;AAAJ;ADrQE;ECoQA;IAGI,cAAA;EAEJ;EAXF;IAcI,YAAA;IACA,WAAA;EAEF;AALF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,+CAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAEF;AD1RE;ECiRF;IASI,uBAAA;EAIF;AACF;;AADA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAIF;;AADA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAIF;;AADA;EACE,wBAAA;EACA,8BAAA;AAIF;;AADA;EACE,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;AAIF;AAFE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAIJ;AADE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AAGJ;AADI;EACE,eAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;AAGN;AAAI;EACE,aAAA;EACA,mBAAA;AAEN;AACI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AACN;ADtVE;ECkVE;IAMI,sBAAA;EAEN;AACF;AAAM;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;AAER;AAGE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;AADJ;AAGI;EAEE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AADN;AAKE;EACE,eAAA;EACA,gBAAA;AAHJ;AAKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHN;AAMI;EACE,gBAAA;EACA,mBAAA;AAJN;AAMM;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAMQ;EACE,mBAAA;AAJV;AAOQ;EACE,wCAAA;EACA,eAAA;AALV;AAQQ;EACE,aAAA;AANV;AAUM;EACE,mBAAA;EACA,8BAAA;AARR;AAUQ;EACE,cAAA;EACA,eAAA;AARV;AAWQ;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AATV;;AAgBA;EACE,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AAbF;AD7aE;ECkbF;IAWI,cAAA;EAZF;AACF","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"../../styles/mixins\";\n\n.__signup_container {\n  background-color: #0d0c0c;\n\n  @include sm{\n    background-color: black;\n  }\n\n  .bg_video{\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n    \n    @include sm{\n      border-bottom: 2px solid #FFEE20;\n      height: 62%;\n    }\n  }\n\n  .__signup {\n    background-color: transparent;\n    position: absolute;\n    width: 444px;\n    top: 0;\n    bottom: 0;\n    right: 0;\n\n    @include sm {\n      width: 100%;\n      height: 50%;\n      position: initial;\n    }\n\n    @include screnRange(2000, 2500) {\n      max-width: 700px;\n      width: 700px;\n    }\n\n    @include screnRange(2501, 4000) {\n      max-width: 900px;\n      width: 900px;\n    }\n\n\n    .___signup_header {\n      padding: 0 58px;\n      position: absolute;\n      top: 60px;\n\n      .___title {\n        font-size: 45px;\n        font-family: \"Anton\", sans-serif;\n        color: #ffffff;\n        margin: 0;\n      }\n\n      .___signup_moto {\n        display: flex;\n        align-items: center;\n      }\n\n      .__hero_title {\n        margin-top: 40px;\n        display: flex;\n        flex-direction: row;\n\n        @include sm {\n          flex-direction: column;\n        }\n\n        p {\n          font-family: \"Helvetica Neue\", sans-serif;\n          font-size: 30px;\n          font-weight: bold;\n        }\n      }\n    }\n   \n    \n\n\n\n    .__signup_action {\n\n      position: absolute;\n      top: 15%;\n      padding: 0 58px;\n      width: auto;\n      margin: auto auto 30px auto;\n      left: 0;\n      right: 0;\n      \n      .login_text{\n        @include sm{\n          display: none;\n        }        \n      }\n      .image_container {\n        display: flex;\n        justify-content: center;\n        gap: 10px; // Adjust the gap between images as needed\n        margin-bottom: 20px; // Adjust margin as needed\n        margin-top: 50%; // Move the container down by adjusting this value\n  \n      \n        .bot_icon {\n          width: 70%; // Adjust width as needed\n          height: 70%; // Adjust height as needed\n          object-fit: contain; // Ensure the image maintains its aspect ratio\n        }\n    \n      }\n\n      @media (max-width: 1036px) {\n        bottom: 0;\n        top: auto;\n      }\n\n      @include sm{\n        bottom: 5%;\n        top: auto;\n      }\n     \n      .gradient_box{\n        background-image: linear-gradient(#000000CC -10%, #FFFFFF);\n        border-radius: 20rem;\n        padding: 1px;\n      }\n      .__action {\n        display: flex;\n        background-color: black;\n        padding: 16px;\n        border-radius: 20rem;\n        justify-content: center;\n        position: relative;\n      }\n\n    }\n  }\n}\n\n.__signup_container_gender {\n  height: 100vh;\n  background-color: #0d0c0c;\n\n  @include screenHeightRange(550, 739) {\n    height: 130vh;\n  }\n\n  @include sm{\n    background-color: #1e1e1e;\n  }\n  \n  .__signup_gender {\n    background-color: #1e1e1e;\n    position: absolute;\n    max-width: 444px;\n    width: 444px;\n    height: 736px;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    right: 0;\n    \n    @include screenHeightRange(550, 739) {\n      margin: 40px auto;\n    }\n    \n    @include sm {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n    }\n\n\n    .__signup_image {\n      position: absolute;\n      top: 0;\n      right: 0;\n    }\n\n    .___gender {\n      padding: 0 58px;\n      margin-top: 60px;\n\n      .__gender_ {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .__gender_container {\n        margin-top: 20px;\n        align-items: center;\n\n        .__select_gender {\n          transition: flex 1s;\n          width: 210px;\n          background: #262626;\n          padding: 10px;\n          border-radius: 25px;\n          align-items: center;\n          justify-content: center;\n\n          &:hover {\n            background: #000000;\n          }\n\n          .__gender_name {\n            color: #ffffff50;\n            font-size: 17px;\n          }\n\n          .__done_icon {\n            display: none;\n          }\n        }\n\n        .__gender_active {\n          width: 210px;\n          background: #000000;\n          justify-content: space-between;\n\n          .__gender_name {\n            color: #ffffff;\n            font-size: 17px;\n          }\n\n          .__done_icon {\n            display: block;\n            background: #FFEE20;\n            border-radius: 50%;\n            color: #000000;\n            font-size: 11px;\n            padding: 2px;\n          }\n        }\n\n        .__select_language {\n          position: relative;\n          transition: height 1s;\n          width: 210px;\n          background: #262626;\n          border-radius: 25px;\n          align-items: center;\n          justify-content: center;\n          height: 50px;\n\n          .__open_select_language {\n            position: absolute;\n            width: inherit;\n            overflow: scroll;\n            position: relative;\n            transition: height 1s;\n            width: 210px;\n            background: #262626;\n            border-radius: 0 0 25px 25px;\n            align-items: center;\n            justify-content: center;\n\n            p {\n              height: 30px;\n              text-align: start;\n              display: flex;\n              align-items: center;\n\n              &:hover {\n                background: #000000;\n              }\n            }\n          }\n        }\n\n        .__open__language {\n          border-radius: 25px 0 0 25px;\n        }\n\n\n      }\n    }\n  }\n}\n\n.__bottom_bg_box_loggedIn{\n  @include sm{\n    background-color: #1e1e1e;\n  }\n}\n\n.__bottom_bg_box {\n  width: 100vw;\n  position: \"absolute\";\n  top: 0;\n  height: 0vh;\n  \n  .login_text_sm{\n    display: none;\n    @include sm{\n      display:block;\n    }\n  }\n  \n  @include sm{\n    height: 45vh;\n    bottom: 0px;\n  }\n}\n\n.__bottom_box {\n  width: 100%;\n  height: 170px;\n  background: #020101 0% 0% no-repeat padding-box;\n  filter: blur(25px);\n  border-radius: 43px;\n  position: absolute;\n  bottom: 0px;\n  @include sm{\n    background: transparent;\n  }\n}\n\n.text {\n  font-size: 14px;\n  color: #828282;\n  text-align: center;\n}\n\n#fname {\n  text-align: center;\n  color: #FFFFFF;\n  border: #262626;\n  font-size: 17px;\n}\n\n.save_btn {\n  margin-top: 0 !important;\n  margin-bottom: 10px !important;\n}\n\n.__signage {\n  background-color: #1e1e1e;\n  position: absolute;\n  top: 2vh;\n  height: fit-content;\n  max-width: 444px;\n  width: 444px;\n  margin: auto;\n  left: 50%;\n  transform: translate(-50%, 0);\n\n  .__signup_image {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  .___signup_header {\n    padding: 0 58px;\n    position: absolute;\n    top: 60px;\n\n    .___title {\n      font-size: 45px;\n      font-family: \"Anton\", sans-serif;\n      color: #ffffff;\n      margin: 0;\n    }\n\n    .___signup_moto {\n      display: flex;\n      align-items: center;\n    }\n\n    .__hero_title {\n      margin-top: 40px;\n      display: flex;\n      flex-direction: row;\n\n      @include sm {\n        flex-direction: column;\n      }\n\n      p {\n        font-family: \"Helvetica Neue\", sans-serif;\n        font-size: 30px;\n        font-weight: bold;\n      }\n    }\n  }\n\n  .__signup_action {\n    position: absolute;\n    bottom: 0px;\n    padding: 0 58px;\n    width: auto;\n    margin: auto auto 30px auto;\n    left: 0;\n    right: 0;\n\n    .__action {\n      display: flex;\n      border: 1px solid #ffffff;\n      padding: 16px;\n      border-radius: 25px;\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n  .___gender {\n    padding: 0 58px;\n    margin-top: 60px;\n\n    .__gender_ {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .__gender_container {\n      margin-top: 24px;\n      align-items: center;\n\n      .__select_gender {\n        transition: flex 1s;\n        min-width: 210px;\n        cursor: pointer;\n        background: #262626;\n        padding: 10px;\n        border-radius: 25px;\n        align-items: center;\n        justify-content: center;\n\n        &:hover {\n          background: #000000;\n        }\n\n        .__gender_name {\n          color: #ffffff50;\n          font-size: 17px;\n        }\n\n        .__done_icon {\n          display: none;\n        }\n      }\n\n      .__gender_active {\n        background: #000000;\n        justify-content: space-between;\n\n        .__gender_name {\n          color: #ffffff;\n          font-size: 17px;\n        }\n\n        .__done_icon {\n          display: block;\n          background: #FFEE20;\n          border-radius: 50%;\n          color: #000000;\n          font-size: 11px;\n          padding: 2px;\n        }\n      }\n    }\n  }\n}\n\n.siki_logo{\n  font-family: Anton !important;\n  font-size: 28px !important;\n  line-height: 28px !important;\n  text-align: center;\n  position: absolute;\n  color: #fff;\n  left: 45%;\n  display: none;\n\n  @include sm{\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
